import type { CoursesLinkPreviewQueryDto } from '@sportspredict/shared';
import type { Wire } from '../../types/common.types';
import { coursesApi } from './courses-base.api';
import type { GetLinkPreviewInput, GetLinkPreviewOutput } from '../../types/link-preview.types';

const TAG = 'courses:link-preview' as const;

export const linkPreviewEndpoints = coursesApi.injectEndpoints({
	endpoints: (builder) => ({
		getLinkPreview: builder.query<GetLinkPreviewOutput, GetLinkPreviewInput>({
			query: (params) => ({
				url: 'courses/public/link-preview',
				params: params satisfies Wire<CoursesLinkPreviewQueryDto>,
			}),
			providesTags: [TAG],
			extraOptions: { skipAuth: true },
		}),
	}),
});

export const { useGetLinkPreviewQuery, useLazyGetLinkPreviewQuery } = linkPreviewEndpoints;
